const PARAGRAPH_PREDICTIONS_BLOCK = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    type
    uuid
    id
    ... on PredictionsBlock {
      id
      sports {
        description
        id
        name
        sportLeague
        url
      }
      iconBlock
      header
      predictionsButton {
        title
        url
      }
      title
      type
      uuid
    }
  }
`;

export default PARAGRAPH_PREDICTIONS_BLOCK;
